module.exports = __webpack_public_path__ + "img/logo-full.877e70f8.png";